// PATH: SaberpDeals/frontend/src/App.tsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/auth/AuthContext';
import Shell from '@/components/Shell';
import LoginPage from '@/pages/LoginPage';
import CatalogPage from '@/pages/CatalogPage';
import PeoplePage from '@/pages/PeoplePage';
import CustomersPage from '@/pages/CustomersPage';
import NewDealPage from '@/pages/NewDealPage';
import DealsPage from '@/pages/DealsPage';

// Gate: while the initial token check runs, render nothing; then either the
// app (if authed) or a redirect to /login.
function Protected({ children }: { children: React.ReactNode }) {
    const { ready, authed } = useAuth();
    if (!ready) return null;
    if (!authed) return <Navigate to="/login" replace />;
    return <Shell>{children}</Shell>;
}

function LoginGate() {
    const { ready, authed } = useAuth();
    if (!ready) return null;
    if (authed) return <Navigate to="/catalog" replace />;
    return <LoginPage />;
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<LoginGate />} />
                    <Route path="/catalog" element={<Protected><CatalogPage /></Protected>} />
                    <Route path="/customers" element={<Protected><CustomersPage /></Protected>} />
                    <Route path="/people" element={<Protected><PeoplePage /></Protected>} />
                    <Route path="/new-deal" element={<Protected><NewDealPage /></Protected>} />
                    <Route path="/deals" element={<Protected><DealsPage /></Protected>} />
                    <Route path="*" element={<Navigate to="/catalog" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
